import {calculateDistance, whenReady} from '../general/Util';
import {showError} from "../general/Error";

class StoreSelector {

	constructor( containerEl ) {
		this.containerEl = containerEl;

		this.selectEl = this.containerEl.querySelector( '.subsidiary-select' );
		this.buttonEl = this.containerEl.querySelector( '.subsidiary-select' );
		this.buttonEl.addEventListener( 'click', () => this.onClick() )
	}

	onClick() {
		if ( ! navigator.geolocation ) {
			showError( this.buttonEl );
		} else {
			navigator.geolocation.getCurrentPosition( this.onSuccess, this.onError );
		}
	}

	onSuccess( pos ) {
		// save values into constants
		const userlat = pos.coords.latitude;
		const userlng = pos.coords.longitude;
		let minDistance = Infinity;
		let minIndex = null;

		// get shop data
		const optionEls = Array.from( this.selectEl.options );

		for ( let i = 0; i < optionEls.length; i++ ) {
			const optionEl = optionEls[i];

			if (
				optionEl.getAttribute( "lat" ) !== null && optionEl.getAttribute( "lat" ) !== "0" &&
				optionEl.getAttribute( "lng" ) !== null && optionEl.getAttribute( "lng" ) !== "0"
			) {
				const shopLat = parseFloat( optionEl.getAttribute( "lat" ) );
				const shopLng = parseFloat( optionEl.getAttribute( "lng" ) );

				if ( shopLat && shopLng ) {
					const dist = calculateDistance( userlat, userlng, shopLat, shopLng );

					if ( dist < minDistance ) {
						minDistance = dist;
						minIndex = optionEl.index;
					}
				}
			}
		}

		if ( minIndex !== null ) {
			this.selectEl.selectedIndex = minIndex;
			// Trigger onchange event of the select, so the correct store gets selected.
			this.selectEl.dispatchEvent( new CustomEvent( 'change', { bubbles: true } ) );
		} else {
			// Display error for user via fallback function.
			this.onError();
		}
	}

	onError() {
		showError( this.buttonEl );
	}
}

const initStoreSelector = ( scopeEl = document ) => {
	const containerEls = scopeEl.querySelectorAll( '.r_storesearch' );
	containerEls.forEach( containerEl => {
		containerEl.ACL_STORE_SELECTION ??= new StoreSelector( containerEl );
	} );
};

// Init.
whenReady.then( () => initStoreSelector() );

// Export.
export {
	StoreSelector as default,
	initStoreSelector
}
